import Prismic from '@prismicio/client';
import { getConfig } from '@tcs/create-account/utils/configService';
import {
  PartnerConfigurationType,
  ResponseType,
  SearchResponseType,
} from '@tcs/create-account/utils/prismic/types';

const getBaseUrl = async () => {
  const config = await getConfig();
  return config.PUBLIC_CMS_URL || 'https://tcsdev.cdn.prismic.io/api/v2';
};

export const GetPrismicClient = async () => Prismic.client(await getBaseUrl());

export const getByIDs = async <T>(
  ids: string[]
): Promise<SearchResponseType<T>> => {
  const API = await Prismic.getApi(await getBaseUrl());
  return await API.getByIDs(ids);
};

export const getDocumentByID = async <T>(
  id: string
): Promise<ResponseType<T>> => {
  const API = await Prismic.getApi(await getBaseUrl());
  return await API.getByID(id);
};

export const getOptionalDocumentByID = async <T>(
  documentId?: string
): Promise<ResponseType<T> | null> => {
  return documentId ? getDocumentByID(documentId) : Promise.resolve(null);
};

export const getDocumentByUID = async (type: string, uid: string) => {
  const API = await Prismic.getApi(await getBaseUrl());
  return await API.getByUID(type, uid);
};

export const getPartnerConfiguration = async (
  partner: string
): Promise<ResponseType<PartnerConfigurationType>> => {
  const queryByPartner = Prismic.Predicates.at(
    `my.partner_configuration.partner_id`,
    partner
  );
  const API = await Prismic.getApi(await getBaseUrl());
  return await API.queryFirst(queryByPartner);
};

export const getPartners = async (): Promise<
  SearchResponseType<PartnerConfigurationType>
> => {
  const queryConfigurations = Prismic.Predicates.at(
    'document.type',
    'partner_configuration'
  );
  const API = await Prismic.getApi(await getBaseUrl());
  return await API.query(queryConfigurations);
};
